import { render } from "./GamePassSteamDeck.vue?vue&type=template&id=44ed7cc3&scoped=true"
import script from "./GamePassSteamDeck.vue?vue&type=script&lang=js"
export * from "./GamePassSteamDeck.vue?vue&type=script&lang=js"

import "./GamePassSteamDeck.vue?vue&type=style&index=0&id=44ed7cc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ed7cc3"]])

export default __exports__